module.exports = __webpack_public_path__ + "media/images/flags/de-ed2b91b80ed1b91bfa1ae48527d49ccb.svg";